<template>
  <div class="recall-team-page">
    <div v-wechat-title="'《提灯与地下城》海灵主宰·龙拳破天'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :gameName="gameName" :game_id="'33'" :downloadUrl="downloadUrl" :loginTypes="loginTypes"
      :autoOpenOS='false' v-on:loginSuccess="loginSuccess" channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <!-- 绑定弹窗 -->
    <Os v-on:getSelectInfo='selectCallback' :gameName='gameName' v-if='isShowOs'></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='isOnline' :newUserInfo="newUserInfo" />
    <!-- 内容 -->

    <div class="active-page">
      <div class="section-container">
        <div class="section section1">
          <div class="code-btn" @click="showPopup('codeShow')" />
          <div class="banner">
            <div class="banner-title" />
          </div>
          <div class="gift-box">
            <div :class="activity.is_send == 1 ? 'opt-btn gift-btn gift-btn-done' : 'opt-btn gift-btn '"
              @click="appoint">
              {{ activity.is_send == 1 ? '已领取' : '立即领取' }}
            </div>
          </div>
          <div v-if="activity.team.team_status === '1'" class="team-box team-box-open" id="team-consumption-box">
            <div class="rule-btn" data-tideng-report-name="规则说明" @click="showPopup('ruleShow')" />
            <div class="team-detail-text">
              <div class="team-num">队伍人数: [{{ activity.team.team_list.length }}/4]</div>
              <div class="team-score">总积分：{{ activity.team.team_score }}</div>
            </div>
            <div class="team-detail">
              <div class="member-list">
                <ul>
                  <li v-for="(item, idx) in teamList" :key="idx">
                    <div v-if="item.id" class="player-info">
                      <img class="avatar" :src="item.pic" alt="">
                      <div v-if="item.is_first" class="captain"></div>
                      <div v-else :class="'medal medal-' + item.status"></div>
                      <div class="name">{{ item.is_myself ? '我' : item.nick_name }}</div>
                    </div>
                    <div v-else>
                      <div class="player-info empty-seat" data-tideng-report-name="邀请好友">
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="score-list">
                <div class="score-item" v-for="(item, idx) in activity.team.team_list" :key="idx">
                  <div class="name">{{ item.nick_name }}</div>
                  <div class="score">
                    <span>{{ item.pay_score + item.task_score }}</span> 分
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div v-else class="team-box" id="team-consumption-box">
            <div class="rule-btn" @click="showPopup('ruleShow')" />
            <div class="team-detail-text">
              <div class="team-num">队伍人数: [{{ activity.team.team_list.length }}/4]</div>
              <div class="team-score">总积分：{{ activity.team.team_score }}</div>
            </div>
            <div class="team-detail">
              <div class="member-list">
                <ul>
                  <li v-for="(item, idx) in teamList" :key="idx">
                    <div v-if="item.id" class="player-info">
                      <img class="avatar" :src="item.pic" alt="">
                      <div v-if="item.is_first" class="captain"></div>
                      <div v-else :class="'medal medal-' + item.status"></div>
                      <div class="name">{{ item.is_myself ? '我' : item.nick_name }}</div>
                      <div class="close" v-if="!item.is_first && userInfo.role_name === teamList[0].role_name"
                        @click="quitPlayerInfo(item.id)"></div>
                    </div>
                    <div v-else>
                      <div class="player-info empty-seat" data-tideng-report-name="邀请好友" @click="onTeamShare()">
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="score-list">
                <div class="score-list-lock"></div>
                <div class="score-item" v-for="(item, idx) in activity.team.team_list" :key="idx">
                  <div class="name">{{ item.nick_name }}</div>
                  <div class="score">
                    <span>{{ item.pay_score + item.task_score }}</span> 分
                  </div>
                </div>
              </div>


            </div>
            <div class="team-btn-box" v-if="activity.team.is_first == 0 && activity.team.team_list.length > 0">
              <div class="opt-btn_active team-up" data-tideng-report-name="退出组队" @click="showPopup('teamExitShow')">退出组队
              </div>
              <div class="opt-btn gift-btn" data-tideng-report-name="邀请好友" @click="onTeamShare()">邀请组队</div>
            </div>

            <div class="team-btn-box" v-else>
              <div class="opt-btn_active team-up" data-tideng-report-name="邀请好友" @click="onTeamShare()">邀请组队
                <div class="tip" />
              </div>
              <div class="opt-btn gift-btn" data-tideng-report-name="开启任务" @click="showPopup('teamOpenShow')">
                开启任务</div>
            </div>
          </div>



          <div class="reward-part">
            <div class="reward-btn-box ">
              <div class="reward-btn" @click="clickRewardType('self')" data-tideng-report-name="个人奖励">
                <div class="reward-btn_active" v-if="reward_type == 'self'" />
                <div class="reward-btn-text">个人奖励</div>
              </div>
              <div class="reward-btn" @click="clickRewardType('team')" data-tideng-report-name="团队奖励">
                <div class="reward-btn_active" v-if="reward_type == 'team'" />
                <div class="reward-btn-text">团队奖励</div>
              </div>
            </div>
            <div class="reward-content-tips">
              <div class="reward-content-score">
                <div class="tips-text">{{ reward_type == 'team' ? '队伍' : '个人' }}总积分:
                  <div class="tips-text-score">&nbsp;{{ reward_type == 'team' ? activity.team.team_score :
                    activity.team.self_score }}</div>分
                </div>
              </div>
              <div class="reward-content-tip"></div>
            </div>
            <div class="reward-content-box">
              <div :class="'reward-content reward-content-' + reward_type">
                <div :class="'reward-content-item reward-content-item-' + (idx + 1)"
                  v-for="(item, idx) in activity.team[reward_type + '_package_list']" :key="idx">

                  <div :class="item._get ? item.is_get ? 'get' : 'light' : 'lock'"></div>
                </div>
                <div class="reward-content-line">
                  <div class="reward-content-line_active" :style="'height:' + getPercentByScore()"></div>
                </div>
              </div>
            </div>
            <div class="reward-content-btn">
              <div class="opt-btn_active" data-tideng-report-name="活动任务" @click="showPopup('taskShow')">活动任务
              </div>
              <div class="opt-btn" data-tideng-report-name="一键领奖" @click="onReward()">一键领奖
              </div>
            </div>
          </div>
          <!-- 任务列表 -->
          <div class="task-new-wrap popup_wrap" v-show="taskShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
              :duration="{ enter: 1000 }">
              <div class="task-box popup_wrap-box" v-show="taskShow">
                <div class="task-list">
                  <div class="task-list-item" v-for="(item, idx) in task_info" :key="item.task_id">
                    <img v-if="activity.team.status == 2" :src="item.img_old" alt="" />
                    <img v-else :src="item.img" alt="" />
                    <div v-if="item.task_id == 1" class="opt-btn task-list-item-btn">完成<span>{{ item.count ? item.count
                      :
                      0 }}</span>次
                    </div>
                    <div v-else :class="'opt-btn task-list-item-btn' + (item.is_get ? '' : ' opt_done')">{{ item.is_get
                      ?
                      (item.task_id == 2 || item.task_id == 3) ? '今日已完成' : '已完成' : '未完成' }}
                    </div>
                  </div>
                </div>
                <div class="close-btn" v-show="taskShow" @click="closePopup('taskShow')" />
              </div>
            </transition>
          </div>
          <!-- 规则 -->
          <div class="order-wrap popup_wrap" v-show="ruleShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
              :duration="{ enter: 1000 }">
              <div class="order-box popup_wrap-box" v-show="ruleShow" style="top:47%">
                <img src="https://download4.qcplay.com/h5-images/active/tideng/recall/rule.png" alt="">
                <div class="close-btn" v-show="ruleShow" @click="closePopup('ruleShow')" />
              </div>
            </transition>
          </div>
          <!-- 官方二维码 -->
          <div class="order-wrap popup_wrap" v-show="codeShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
              :duration="{ enter: 1000 }">
              <div class="order-box popup_wrap-box" v-show="codeShow" style="top:47%">
                <img src="https://download4.qcplay.com/h5-images/active/tideng/recall/code.png" alt="">

                <a class="opt-btn wrap-btn-single" data-tideng-report-name="立即关注" @click="goLink(activity.link)"
                  style="bottom: 8.5%;">立即关注</a>

                <div class="close-btn" v-show="codeShow" @click="closePopup('codeShow')" />
              </div>
            </transition>
          </div>

          <!-- 绑定角色提示 -->
          <div class="order-wrap popup_wrap" v-show="bindShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
              :duration="{ enter: 1000 }">
              <div class="order-box popup_wrap-box" v-show="bindShow">

                <img src="https://download4.qcplay.com/h5-images/active/tideng/recall/bind.png" alt="">
                <div class="opt-btn-box" style="bottom: 12%;width: 75%;">
                  <div class="opt-btn_active wrap-btn" @click="closePopup('bindShow')">我再想想</div>
                  <div class="opt-btn wrap-btn" @click="bindRole">确认绑定</div>
                </div>
              </div>
            </transition>
            <div class="close-bg" v-show="bindShow" @click="closePopup('bindShow')"></div>
          </div>
          <!-- 预约领取奖励 -->
          <div class="order-wrap popup_wrap" v-show="orderSuccessShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
              :duration="{ enter: 1000 }">
              <div class="order-box popup_wrap-box" v-show="orderSuccessShow">

                <img src="https://download4.qcplay.com/h5-images/active/tideng/recall/order_success.png" alt="">
                <div class="opt-btn wrap-btn-single" @click="closePopup('orderSuccessShow')">我已知晓</div>
              </div>
            </transition>
            <div class="close-bg" v-show="orderSuccessShow" @click="closePopup('orderSuccessShow')"></div>
          </div>
          <!-- 队伍开启 -->
          <div class="order-wrap popup_wrap" v-show="teamOpenShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
              :duration="{ enter: 1000 }">
              <div class="order-box popup_wrap-box" v-show="teamOpenShow" style="width: 120vw;">
                <div class="order-info">
                  <p v-if="activity.team.team_list.length == 4">恭喜您组队成功获得满员福利<span>100</span>积分</p>
                  <p v-else>邀请更多提灯老友加速解锁大奖</p>
                </div>
                <img src="https://download4.qcplay.com/h5-images/active/tideng/recall/open.png" alt="">
                <div class="opt-btn-box">
                  <div class="opt-btn_active wrap-btn" @click="closePopup('teamOpenShow')">我再想想</div>
                  <div class="opt-btn wrap-btn" data-tideng-report-name="队伍开启" @click="teamOpen">开启任务</div>
                </div>
              </div>
            </transition>
            <div class="close-bg" v-show="teamOpenShow" @click="closePopup('teamOpenShow')"></div>
          </div>
          <!-- 召回分享 -->
          <div class="recall-share-box" ref="recallImageDom">
            <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-share-popup.png" />
            <div class="share-img">
              <div class="qrcode-box">
                <div id="recall-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
          <!-- 组队消费分享 -->
          <div class="team-share-box" ref="teamImageDom">
            <img src="https://download4.qcplay.com/h5-images/active/tideng/recall/share.png" />
            <div class="team-info">
              <p>当前小队人数：<span>{{ memberNum === 0 ? 1 : memberNum }}</span>人</p>
              <p>剩余<span>{{ memberNum === 0 ? 3 : Math.max(4 - memberNum, 0) }}</span>空位</p>
            </div>
            <div class="share-img">
              <div class="qrcode-box">
                <div id="team-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 召回绑定弹窗组 -->
    <div>
      <!-- 召回绑定——详情弹窗 -->
      <div class="recall-detail-wrap popup_wrap" v-show="recallDetailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-detail-box popup_wrap-box" v-show="recallDetailShow">
            <div class="detail-content" v-if="recallDetailShow">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-rule.png" alt="">
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallDetailShow" @click="closePopup('recallDetailShow')"></div>
      </div>

      <!-- 召回绑定——召回失败(不符合条件) -->
      <div class="recall-failed-mismatch-condition-wrap popup_wrap" v-show="recallFailedMismatchConditionShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-mismatch-condition-box popup_wrap-box" v-show="recallFailedMismatchConditionShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-tideng-report-name="召回失败-参加其他活动"
                @click="toIndex('recallFailedMismatchConditionShow')"></div>
              <div class="btn recall-btn" data-tideng-report-name="老友活动-召回其他人" @click="onRecallOther()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMismatchConditionShow"
          @click="closePopup('recallFailedMismatchConditionShow')"></div>
      </div>
      <!-- 召回绑定——召回失败(不符合条件2 都是回归玩家) -->
      <div class="recall-failed-mismatch-condition-2-wrap popup_wrap" v-show="recallFailedMismatchConditionShow2">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-mismatch-condition-2-box popup_wrap-box"
            v-show="recallFailedMismatchConditionShow2">
            <div class="btn-box">
              <div class="btn qq-btn" data-tideng-report-name="召回失败-前往QQ群" @click="toGroupOfQQ()"></div>
              <div class="btn wechat-btn" data-tideng-report-name="召回失败-前往微信群" @click="toGroupOfWechat()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMismatchConditionShow2"
          @click="closePopup('recallFailedMismatchConditionShow2')"></div>
      </div>

      <!-- 召回绑定——召回失败(自己召回自己弹窗) -->
      <div class="recall-failed-myself-wrap recall-failed-wrap popup_wrap" v-show="recallFailedMyselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-myself-box popup_wrap-box" v-show="recallFailedMyselfShow">
            <div class="fail-tips">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-fail-text-1.png"
                alt="">
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-tideng-report-name="召回失败-参加其他活动"
                @click="toIndex('recallFailedMyselfShow')"></div>
              <div class="btn recall-btn" data-tideng-report-name="老友活动-召回其他人" @click="onRecallOther()"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 召回绑定——召回失败(已经满员弹窗) -->
      <div class="recall-failed-full-strength-wrap recall-failed-wrap popup_wrap" v-show="recallFailedFullStrengthShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-full-strength-box popup_wrap-box" v-show="recallFailedFullStrengthShow">
            <div class="fail-tips">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-fail-text-2.png"
                alt="">
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-tideng-report-name="召回失败-参加其他活动"
                @click="toIndex('recallFailedFullStrengthShow')"></div>
              <div class="btn recall-btn" data-tideng-report-name="老友活动-召回其他人" @click="onRecallOther()"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 召回绑定——召回失败(已有队伍弹窗) -->
      <div class="recall-failed-has-team-wrap recall-failed-wrap popup_wrap" v-show="recallFailedHasTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-has-team-box popup_wrap-box" v-show="recallFailedHasTeamShow">
            <div class="fail-tips">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-fail-text-3.png"
                alt="">
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-tideng-report-name="召回失败-参加其他活动"
                @click="toIndex('recallFailedHasTeamShow')"></div>
              <div class="btn my-team-btn" data-tideng-report-name="老友活动-查看我的组队" @click="toMyTeamByRecall()"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 召回绑定——召回邀请 -->
      <div class="recall-invitation-wrap popup_wrap" v-show="recallInvitationShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-invitation-box popup_wrap-box" v-show="recallInvitationShow">
            <div class="player-box">
              <div class="player-item player-1">
                <img v-if="activeInfo.invite" class="avatar" :src="activeInfo.invite.pic" alt="">
                <div v-if="activeInfo.invite" :class="'medal medal-' + activeInfo.invite.status"></div>
                <div class="name">我</div>
              </div>
              <div class="player-item player-2">
                <img class="avatar" :src="recallSharePlayerInfo.share_pic" alt="">
                <div :class="'medal medal-' + recallSharePlayerInfo.share_status"></div>
                <div class="name">{{ recallSharePlayerInfo.share_nick_name }}</div>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-tideng-report-name="老友活动-残忍拒绝"
                @click="toIndex('recallInvitationShow')"></div>
              <div class="btn my-team-btn" data-tideng-report-name="老友活动-接受邀请" @click="acceptInvitation()"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- 组队消费——队长踢出队员 -->
    <div class="team-quit-player-info-wrap popup_wrap" v-show="teamPlayerKickOutInfoShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerKickOutInfoShow">
          <div class="player-info">
            <div class="top">
              <div class="avatar-box">
                <img class="avatar" :src="curPlayerInfo.pic" alt="">
              </div>
              <div class="name">{{ curPlayerInfo.nick_name || '' }}</div>
            </div>

            <div class="info">
              <div class="row">
                <div class="label">账号状态：</div>
                <div class="value">{{ curPlayerInfo.type_desc || '' }}</div>
              </div>
            </div>
            <div class="info-title">队伍即将满员,是否踢出该队友？</div>
          </div>

          <div class="opt-btn-box">
            <div class="opt-btn_active wrap-btn" @click="onKickOut('team', curPlayerInfo)">踢出队伍</div>
            <div class="opt-btn wrap-btn" @click="closePopup('teamPlayerKickOutInfoShow')">我再想想</div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 组队消费弹窗组 -->
    <div>
      <!-- 组队消费——详情弹窗 -->
      <div class="team-detail-wrap popup_wrap" v-show="teamDetailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-detail-box popup_wrap-box" v-show="teamDetailShow">
            <div class="detail-content" v-if="teamDetailShow">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/team-rule.png" alt="">
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamDetailShow" @click="closePopup('teamDetailShow')"></div>
      </div>

      <!-- 组队消费——玩家信息 -->
      <div class="team-player-info-wrap popup_wrap" v-show="teamPlayerInfoShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow">
            <div class="player-info">
              <div class="top">
                <div class="avatar-box">
                  <img class="avatar" :src="curPlayerInfo.pic" alt="">
                </div>
                <div class="name">{{ curPlayerInfo.nick_name || '' }}</div>
              </div>

              <div class="info">
                <div class="row">
                  <div class="label">账号状态：</div>
                  <div class="value">{{ curPlayerInfo.type_desc || '' }}</div>
                </div>
                <div class="row">
                  <div class="label">上次登录时间：</div>
                  <div class="value">{{ `${curPlayerInfo.lastTime || ''}` }}</div>
                </div>
                <div class="row">
                  <div class="label">贡献积分：</div>
                  <div class="value">{{ isActiveAppointment ? 0 : (Number(curPlayerInfo.score) + 20) }}</div>
                </div>
              </div>
            </div>

            <div :class="'btn-box align-' + curPlayerInfo.is_kick_out">
              <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow')"></div>
              <div class="btn" v-if="curPlayerInfo.is_kick_out">
                <div v-if="showGrayKickOutBtn" class="gray-kick-out-btn">
                  <span>倒计时:{{ kickOutSeconds }}秒</span>
                </div>
                <div v-else class="kick-out-btn" @click="onKickOut()"></div>
              </div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamPlayerInfoShow" @click="closePopup('teamPlayerInfoShow')"></div>
      </div>

      <!-- 组队消费——玩家退出队伍弹窗 -->
      <div class="team-exit-wrap popup_wrap" v-show="teamExitShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-exit-box popup_wrap-box" v-show="teamExitShow">
            <!-- <div class="tips">
              当前队伍人数：{{ memberNum }}人
            </div> -->
            <div class="btn-box">
              <div class="btn confirm-btn" data-tideng-report-name="退出队伍弹窗-确认退出" @click="onExitTeam('self', userInfo)">
              </div>
              <div class="btn cancel-btn" @click="closePopup('teamExitShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamExitShow" @click="closePopup('teamExitShow')"></div>
      </div>

      <!-- 组队消费——玩家被踢出队伍提示弹窗 -->
      <div class="team-player-kick-out-tip-wrap popup_wrap" v-show="teamKickOutTipShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-player-kick-out-tip-box popup_wrap-box" v-show="teamKickOutTipShow">
            <div class="text">您已被踢出队伍</div>
            <div class="btn-box">
              <div class="btn confirm-btn" @click="closePopup('teamKickOutTipShow')"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 组队消费——积分记录弹窗 -->
      <div class="team-points-record-wrap popup_wrap" v-show="teamPointsRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-points-record-box popup_wrap-box" v-show="teamPointsRecordShow">
            <div class="record-box">
              <ul>
                <li v-for="(item, idx) of scoreList" :key="idx">
                  <div class="left">
                    <div class="name">{{ item.remark }}</div>
                    <div class="date">{{ item.created_at && formatDate(item.created_at) }}</div>
                  </div>
                  <div class="right">积分:<span>{{ item.score }}</span></div>
                </li>
              </ul>
            </div>

            <div class="tips">
              <p>当前累计积分为：<span>{{ teamScore || 0 }}</span></p>
            </div>

          </div>
        </transition>
        <div class="close-bg" v-show="teamPointsRecordShow" @click="closePopup('teamPointsRecordShow')"></div>
      </div>
      <!-- 组队消费——积分记录弹窗 无积分 -->
      <div class="team-not-points-record-wrap popup_wrap" v-show="teamNotPointsRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-not-points-record-box popup_wrap-box" v-show="teamNotPointsRecordShow">
            <div class="btn-box">
              <div class="btn confirm-btn" data-tideng-report-name="获取积分" @click="toRecharge()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamNotPointsRecordShow" @click="closePopup('teamNotPointsRecordShow')"></div>
      </div>

      <!-- 组队消费——入队失败(满员) -->
      <div class="team-join-failed-full-strength-wrap popup_wrap" v-show="teamJoinFailedFullStrengthShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-join-failed-full-strength-box popup_wrap-box" v-show="teamJoinFailedFullStrengthShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="toIndex('teamJoinFailedFullStrengthShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedFullStrengthShow"
          @click="closePopup('teamJoinFailedFullStrengthShow')"></div>
      </div>
      <!-- 组队消费——入队失败(已有队伍) -->
      <div class="team-join-failed-has-team-wrap popup_wrap" v-show="teamJoinFailedHasTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-join-failed-has-team-box popup_wrap-box" v-show="teamJoinFailedHasTeamShow">

            <div class="btn-box">
              <div class="btn other-active-btn" @click="toMyTeamByTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedHasTeamShow" @click="closePopup('teamJoinFailedHasTeamShow')"></div>
      </div>
      <!-- 组队消费——入队失败(自己邀请自己) -->
      <div class="team-join-failed-myself-wrap popup_wrap" v-show="teamJoinFailedMyselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-join-failed-myself-box popup_wrap-box" v-show="teamJoinFailedMyselfShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="toMyTeamByTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedMyselfShow" @click="closePopup('teamJoinFailedMyselfShow')"></div>
      </div>
      <!-- 组队消费——邀请入队弹窗 -->
      <div class="team-invitation-join-wrap popup_wrap" v-show="teamInvitationJoinShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-invitation-join-box popup_wrap-box" v-show="teamInvitationJoinShow">
            <div class="team-title">
              <p>是否接受邀请?</p>
              <p><span>*您{{ activity.team.status == 2 ? '' : '不' }}是提灯老友</span></p>
            </div>
            <div class="team-info">
              <p>当前小队人数:<span>{{ teamInvitationNum === 0 ? 1 : teamInvitationNum }}</span>人</p>
              <p>剩余<span>{{ teamInvitationNum === 0 ? 3 : Math.max(4 - teamInvitationNum, 0) }}</span>个空位</p>
            </div>
            <div class="opt-btn-box">
              <div class="opt-btn_active reject-btn" data-tideng-report-name="组队消费-拒绝入队" @click="rejectJoinTeam()">残忍拒绝
              </div>
              <div class="opt-btn agree-btn" data-tideng-report-name="组队消费-立即入队" @click="agreeJoinTeam()">接受邀请</div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamInvitationJoinShow" @click="closePopup('teamInvitationJoinShow')"></div>
      </div>
      <!-- 组队消费——邀请入队确认弹窗 -->
      <div class="team-invitation-confirm-wrap popup_wrap" v-show="teamInvitationConfirmShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-invitation-confirm-box popup_wrap-box" v-show="teamInvitationConfirmShow">
            <div class="team-info">
              <p>当前小队人数：{{ teamInvitationNum === 0 ? 1 : teamInvitationNum }}</p>
              <p>剩余空位：{{ teamInvitationNum === 0 ? 5 : Math.max(6 - teamInvitationNum, 0) }}</p>
              <p>奖励解锁等级：{{ Math.min(teamLevel, 10) }}(共10级)</p>
            </div>
            <div class="btn-box">
              <div class="btn confirm-btn" data-tideng-report-name="组队消费-二次确认确定入队" @click="agreeJoinTeam()"></div>
              <div class="btn cancel-btn" data-tideng-report-name="组队消费-二次确认拒绝入队" @click="rejectJoinTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamInvitationConfirmShow" @click="closePopup('teamInvitationConfirmShow')"></div>
      </div>
    </div>

    <!-- 召回绑定——微信分享 -->
    <div class="recall-wechat-share-wrap popup_wrap" v-show="recallWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div
          :class="'recall-wechat-share-box popup_wrap-box ' + ((activeInfo.invite && ([1, 3].includes(activeInfo.invite.status))) ? 'new_player' : '')"
          v-show="recallWechatShareShow">
        </div>
      </transition>
      <div class="close-bg" v-show="recallWechatShareShow" @click="closeWechatShare('recallWechatShareShow')"></div>
    </div>
    <!-- 召回绑定——分享弹窗 -->
    <div class="recall-share-wrap popup_wrap" v-show="recallNotWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="recall-share-box popup_wrap-box" v-show="recallNotWechatShareShow">
          <img :src="recallShareImg" alt="分享图片" />
          <div class="share-tips"></div>
          <button class="monitor-btn" @click="onCopy('recall-clipboard-btn')" id="recall-clipboard-btn"
            data-tideng-report-name="老友活动弹窗-复制链接" data-event="复制邀请链接"
            :data-clipboard-text="recallShareCopy.linkText + recallShareLink"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="recallNotWechatShareShow" @click="closePopup('recallNotWechatShareShow')"></div>
    </div>
    <!-- 组队消费——微信分享 -->
    <div class="team-wechat-share-wrap popup_wrap" v-show="teamWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-wechat-share-box popup_wrap-box" v-show="teamWechatShareShow"
          @click="closeWechatShare('teamWechatShareShow')">
        </div>
      </transition>
    </div>
    <!-- 组队消费——分享弹窗 -->
    <div class="team-share-wrap popup_wrap" v-show="teamNotWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-share-box popup_wrap-box" v-show="teamNotWechatShareShow">
          <img :src="teamShareImg" alt="分享图片" />
          <button class="opt-btn monitor-btn" @click="onCopy('team-clipboard-btn')" id="team-clipboard-btn"
            data-tideng-report-name="付费活动弹窗-复制链接" data-event="复制邀请链接"
            :data-clipboard-text="teamShareCopy.linkText + teamShareLink">复制链接</button>
          <div class="close-btn" v-show="teamNotWechatShareShow" @click="closePopup('teamNotWechatShareShow')"></div>
        </div>
      </transition>
    </div>




    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div class="btn qq-btn" data-tideng-report-name="寻找搭子弹窗-去QQ" @click="toGroupOfQQ()"></div>
            <div class="btn wechat-btn" data-tideng-report-name="寻找搭子弹窗-去微信" @click="toGroupOfWechat()"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="findTeamShow" @click="closePopup('findTeamShow')"></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button class="monitor-btn" @click="onCopy('qq-clipboard-btn')" id="qq-clipboard-btn"
            data-tideng-report-name="复制QQ群号" data-event="复制QQ群号" :data-clipboard-text="qqNumber"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="qqGroupShow" @click="closePopup('qqGroupShow')"></div>
    </div>

    <!-- 奖励弹窗组 -->
    <div>
      <!-- 奖励弹窗——卡片形象详情 -->
      <div class="character-wrap popup_wrap" v-show="characterShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="character-box popup_wrap-box" v-show="characterShow">
            <div class="btn close-btn" @click="closePopup('characterShow')"></div>
          </div>
        </transition>
        <div class="close-bg" v-show="characterShow" @click="closePopup('characterShow')"></div>
      </div>

      <!-- 奖励弹窗——启航携手礼包 -->
      <div class="cooperation-wrap popup_wrap" v-show="cooperationShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="cooperation-box popup_wrap-box" v-show="cooperationShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('cooperationShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="cooperationShow" @click="closePopup('cooperationShow')"></div>
      </div>

      <!-- 奖励弹窗——奇点水晶礼包 -->
      <div class="crystal-wrap popup_wrap" v-show="crystalShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="crystal-box popup_wrap-box" v-show="crystalShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('crystalShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="crystalShow" @click="closePopup('crystalShow')"></div>
      </div>

      <!-- 奖励弹窗——组队幸运礼包 -->
      <div class="lucky-wrap popup_wrap" v-show="luckyShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="lucky-box popup_wrap-box" v-show="luckyShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('luckyShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="luckyShow" @click="closePopup('luckyShow')"></div>
      </div>

      <!-- 奖励弹窗——贵重物品详情 -->
      <div class="valuables-wrap popup_wrap" v-show="valuablesShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="valuables-box popup_wrap-box" v-show="valuablesShow">
          </div>
        </transition>
        <div class="close-bg" v-show="valuablesShow" @click="closePopup('valuablesShow')"></div>
      </div>
      <!-- 奖励弹窗——贵重物品详情 -->
      <div class="activity-benefits-wrap popup_wrap" v-show="activityBenefitsShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="activity-benefits-box popup_wrap-box" v-show="activityBenefitsShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('activityBenefitsShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="activityBenefitsShow" @click="closePopup('activityBenefitsShow')"></div>
      </div>
    </div>


    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { GetRoleList } from "@/api/os";
import Login from '@/components/login';
import Os from '@/components/os';
import Header from '../Header/index.vue';
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { headerConfig } from '../headerConfig';
import {
  onGetInitDataAPI, recallInitAPI, teamInitAPI, recallBindPlayerAPI, appointAPI, getAPI, teamOpen, inviteTeamInit, reward,
  teamKickAPI, teamExitAPI, teamRewardAPI, teamJoinAPI
} from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

// import eruda from 'eruda';

const PLAYER_TYPE = {
  1: '活跃玩家',
  2: '回归玩家',
  3: '新玩家',
};
const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
const ACTIVE_PROCEED_STATUS = 2; // 活动进行期间

export default {
  name: 'RecallTeamActive',
  components: {
    Header,
    Login,
    Os,
  },
  props: {
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum('拳新版本-组队页');
        }
      }
    }
  },
  data() {
    return {
      isOnline: 0,
      orderSuccessShow: false,
      teamOpenShow: false,
      bindShow: false,
      codeShow: false,
      ruleShow: false,
      taskShow: false,
      reward_type: 'self',
      selectCallback_Info: {},
      newUserInfo: {},
      task_info: [
        {
          task_id: 1,
          title: '游戏充值每满6元',
          type: 1,
          is_limit: 1,
          score: 150,
          add_score: 200,
          package_id: 1,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/pay.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/pay.png'
        },
        {
          task_id: 2,
          title: '每日登录游戏',
          type: 2,
          is_limit: 1,
          score: 100,
          add_score: 200,
          package_id: 462,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login1.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login1.png'
        },
        {
          task_id: 3,
          title: '每日消耗100精力',
          type: 3,
          is_limit: 100,
          score: 100,
          add_score: 200,
          package_id: 0,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy.png'
        },
        {
          task_id: 4,
          title: '精力消耗达200点',
          type: 3,
          is_limit: 200,
          score: 200,
          add_score: 300,
          package_id: 0,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy200.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy200.png'
        },
        {
          task_id: 5,
          title: '精力消耗达400点',
          type: 3,
          is_limit: 400,
          score: 400,
          add_score: 600,
          package_id: 463,
          desc: '(内含以下游戏道具奖励)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy400.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy400.png'
        },
        {
          task_id: 6,
          title: '精力消耗达600点',
          type: 3,
          is_limit: 600,
          score: 600,
          add_score: 900,
          package_id: 0,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy600.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy600.png'
        },
        {
          task_id: 7,
          title: '精力消耗达1000点',
          type: 3,
          is_limit: 1000,
          score: 1000,
          add_score: 1500,
          package_id: 462,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy1000.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy1000.png'
        },
        {
          task_id: 8,
          title: '完成登录2天',
          type: 4,
          is_limit: 2,
          package_id: 0,
          score: 100,
          add_score: 150,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login2.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login2.png'
        },
        {
          task_id: 9,
          title: '完成登录3天',
          type: 4,
          is_limit: 3,
          package_id: 0,
          score: 300,
          add_score: 450,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login3.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login3.png'
        },
        {
          task_id: 10,
          title: '完成登录5天',
          type: 4,
          is_limit: 5,
          package_id: 463,
          score: 500,
          add_score: 750,
          desc: '(内含以下游戏道具奖励)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login5.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login5.png'
        },
        {
          task_id: 11,
          title: '完成登录7天',
          type: 4,
          is_limit: 7,
          package_id: 463,
          score: 1000,
          add_score: 1500,
          desc: '(内含以下游戏道具奖励)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login7.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login7.png'
        }
      ],
      activity: {
        is_bind: 0,
        is_send: 0,
        is_reward_start: false,
        team: {
          status: 0,
          "team_score": 0,
          "code": "",
          "self_score": 0,
          "team_status": 0,
          team_list: [],
          is_first: 3,
          status: 1,
          "self_package_list": [
            {
              "number": 1,
              "score": 100,
              "_get": false,
              "is_get": false
            },
            {
              "number": 2,
              "score": 500,
              "_get": false,
              "is_get": false
            },
            {
              "number": 3,
              "score": 1000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 4,
              "score": 5000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 5,
              "score": 6000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 6,
              "score": 7000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 7,
              "score": 8000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 8,
              "score": 9000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 9,
              "score": 10000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 10,
              "score": 11000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 11,
              "score": 12000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 12,
              "score": 13000,
              "_get": false,
              "is_get": false
            },
          ],
          "team_package_list": [
            {
              "number": 1,
              "score": 500,
              "_get": false,
              "is_get": false
            },
            {
              "number": 2,
              "score": 1500,
              "_get": false,
              "is_get": false
            },
            {
              "number": 3,
              "score": 5000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 4,
              "score": 10000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 5,
              "score": 15000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 6,
              "score": 20000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 7,
              "score": 30000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 8,
              "score": 9000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 9,
              "score": 10000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 10,
              "score": 11000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 11,
              "score": 12000,
              "_get": false,
              "is_get": false
            },
            {
              "number": 12,
              "score": 13000,
              "_get": false,
              "is_get": false
            },
          ],
        },
        user_info: {}
      },
      headerConfig,
      gameName: 'tideng',
      downloadUrl: 'https://tideng.qingcigame.com/',
      rechargeUrl: 'https://pay.qingcigame.com/pay?gameId=39',
      loginTypes: ["sms", "password"],
      autoOpenOS: false,
      preloadingShow: true,
      timer: null,
      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      consumptionLevel: [50, 100, 150, 200, 400, 800, 1500, 3000, 5000, 10000],
      recallShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },
      teamShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },

      code: '',
      auth_code: '',
      friend_id: '',
      recallShareLink: '',
      teamShareLink: '',
      recallShareImg: '',
      teamShareImg: '',

      // 弹窗
      preventShow: false, // 全局遮罩
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群
      recallDetailShow: false, // 召回绑定——详情弹窗
      recallWechatShareShow: false, // 召回绑定——微信分享弹窗
      recallNotWechatShareShow: false, // 召回绑定——非微信分享弹窗
      recallFailedMismatchConditionShow: false, // 召回绑定——不满足条件弹窗
      recallFailedMyselfShow: false, // 召回绑定——自己召回自己弹窗
      recallFailedFullStrengthShow: false, // 召回绑定——已有好友弹窗
      recallFailedHasTeamShow: false, // 召回绑定——已有队伍弹窗
      recallFailedMismatchConditionShow2: false, // 召回绑定——都是回归玩家
      recallInvitationShow: false, // 召回绑定——邀请弹窗

      teamDetailShow: false, // 组队消费——详情弹窗
      teamWechatShareShow: false, // 组队消费——微信分享弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow: false, // 组队消费——玩家信息弹窗
      teamPlayerKickOutInfoShow: false, // 组队消费——队长踢出玩家
      teamKickOutTipShow: false, // 组队消费——玩家被踢出队伍弹窗
      teamExitShow: false, // 组队消费——退出队伍弹窗
      teamBindRoleConfirmShow: false, // 组队消费——绑定角色确认弹窗
      teamPointsRecordShow: false, // 组队消费——积分记录弹窗
      teamNotPointsRecordShow: false, // 组队消费——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗
      teamInvitationConfirmShow: false, // 组队消费——邀请入队确认弹窗

      characterShow: false, // 奖励弹窗——卡片形象详情
      cooperationShow: false, // 奖励弹窗——启航携手礼包
      crystalShow: false, // 奖励弹窗——奇点水晶礼包
      luckyShow: false, // 奖励弹窗——组队幸运礼包
      valuablesShow: false, // 奖励弹窗——贵重物品详情
      activityBenefitsShow: false, // 奖励弹窗——运营活动福利礼包

      recallActiveInfo: {},
      teamActiveInfo: {},
      teamList: Array.from({ length: 4 }, () => ({})),
      packageList: Array.from({ length: 10 }, () => ({})),
      memberNum: 0,
      curPlayerInfo: {},
      invitePartnerInfo: {},

      // 是否需要二次同意
      needInvitationConfirm: false,

      roleList: [],
      selectedRoleID: "",
      isActiveAppointment: true, // 默认在预约期

      recallSharePlayerInfo: {},
      teamInvitationNum: 0,
      teamLevel: 0,
      teamScore: 0,
      scoreList: [],
      rewardLevel: 0,
      rewardList: [],
      selectedRoleInfo: {},
      qqNumber: '',
      qqLink: '',
      wechatLink: '',
      pageLink: '',
      mapping: {
        self: [
          { score: 100, percent: 5 },
          { score: 500, percent: 20 },
          { score: 1000, percent: 35 },
          { score: 5000, percent: 50 },
          { score: 6000, percent: 65 },
          { score: 7000, percent: 80 },
          { score: 8000, percent: 95 }
        ],
        team: [
          { score: 500, percent: 5 },
          { score: 1500, percent: 20 },
          { score: 5000, percent: 35 },
          { score: 10000, percent: 50 },
          { score: 15000, percent: 65 },
          { score: 20000, percent: 80 },
          { score: 30000, percent: 95 }
        ],
      }
    }
  },
  created() {
    const targetDate = new Date('2025/06/20 4:59:59');
    // 获取当前时间
    const currentDate = new Date();
    // 计算时间差
    const timeDifference = targetDate - currentDate;
    // 如果时间差大于0，说明在预约期，否则不在预约期
    this.isActiveAppointment = timeDifference ? true : false;
    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    this.friend_id = urlParams.get('friend_id');
    const queryUA = urlParams.get('ua');
    const module = urlParams.get('module');
    const type = urlParams.get('type');

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('friend_id');
    urlParams.delete('module');
    urlParams.delete('ua');
    urlParams.delete('type');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 创建一个数组，长度为6，里面元素是空对象
    this.teamList = Array.from({ length: 4 }, () => ({}));
    if (type === 'by3') {
      this.headerConfig.operation_btn.download.link = 'https://download4.qcplay.com/apk-v2/qc-kol-1168625.apk'
    } else {
      this.headerConfig.operation_btn.download.link = 'https://download4.qcplay.com/apk-v2/qc-kol-1168626.apk'
    }
    if (/iP(hone|od|ad)/.test(navigator.userAgent)) {
      this.headerConfig.operation_btn.download.link = 'https://apps.apple.com/cn/app/%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E-1-5%E7%89%88%E6%9C%AC%E5%85%89%E6%9A%97%E5%AF%B9%E5%86%B3/id1507356201?l=en'
    }
    this.$set(this, 'headerConfig', headerConfig)
    // 初始化
    this.onInitDate(true);
    if (module === 'recall') {
      this.$nextTick(() => {
        this.scrollIntoRecallBox();
      });
    } else if (module === 'team') {
      this.$nextTick(() => {
        this.scrollIntoTeamBox();
      });
    }
    if (queryUA === 'tideng') {
      this.rechargeUrl = 'https://pay.qingcigame.com/pay?gameId=33&ua=tideng';
    }
    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: "《提灯与地下城》新版本上线",
      imgUrl: 'https://download4.qcplay.com/qcgame-api/9VHWniV91Q3sfOtCISCEmR9aWVEaAj7jLqrT2VKZ.png',
      desc: "《提灯与地下城》组队积分活动，可获得史诗级头衔：海灵主宰·龙拳破天、10星装备升星券、钻石*1000等丰厚奖励，集结归来的灯友，就差你了！",
    });

  },
  mounted() {
    this.logger.sum('拳新版本-组队页');
    this.$nextTick(() => {
      document.addEventListener('click', this.handleGlobalClick, true);
    })
    // let el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({
    //   container: el,
    //   useShadowDom: true
    // });
  },
  computed: {
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName = this.selectedRoleID
        ? this.roleList.find(item => item.role_id === this.selectedRoleID).role_name
        : "";
      return roleName;
    },
    finallyScore() {
      if (!this.activeInfo.team) {
        return 0;
      }
      const num = this.packageList[9].has_get_time;
      if (num === 20) {
        return 10000;
      }
      return this.teamScore - num * 10000;
    },
    finallyProcess() {
      if (!this.finallyScore) {
        return 0;
      }
      return Math.min((this.finallyScore / 10000) * 100, 100);
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          console.log('初始登陆/切换角色')
          // this.getRecallInit();
          this.getTeamInit();
          const { protocol, host } = window.location;
          this.teamShareLink = `${protocol}//${host}/tideng/recall/enter${getRandomString()}?friend_id=${this.activeInfo.team.code}`;
          this.initTeamShareData();

        }
      }
    }
  },
  methods: {
    //绑定角色
    bindRole() {
      const that = this
      const praams = {
        ...this.selectCallback_Info,
        type: 2,
        is_bind: 1,
      }
      reward(praams).then((response) => {
        if (response.code == 200) {
          that.onToast(response.message); //绑定成功
          this.onInitDate()
          if (that.friend_id) {
            that.getTeamInit()
          }
          that.closePopup('bindShow')
        } else {
          that.onToast(response.message);
        }
      })
    },
    // 开启组队
    teamOpen() {

      // 有无登录
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        // this.autoOpenOS = true;
        this.changeLoginPopup(true);
        return
      }

      teamOpen().then((response) => {
        if (response.code == 200) {
          this.teamOpenShow = false;
          this.logger.sum('拳新版本组队-开启组队成功');
          this.onInitDate()
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 预约
    appoint() {

      // 有无登录
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        // this.autoOpenOS = true;
        this.changeLoginPopup(true);
        return
      }
      if (this.activity.is_bind == 0) {
        this.showPopup('bindShow');
        return
      }
      let extraValue = ''
      if (this.selectCallback_Info && this.selectCallback_Info.extra) {
        // 如果有 extra 属性，就用它
        extraValue = this.selectCallback_Info.extra;
      } else {
        // 不存在或者 undefined/null 就设为空
        extraValue = '';
      }
      const params = {
        ...this.userInfo,
        platform: this.userInfo.channel,
        extra: extraValue,
      }
      if (this.activity.is_reward_start) {
        getAPI(params).then((response) => {
          if (response.code == 200) {
            this.activity.is_send = 1
            // this.showPopup('orderSuccessShow');
            this.onToast('大礼包已发送至邮箱!');
            this.logger.sum('拳新版本组队-领取成功');
          } else {
            this.onToast(response.message);
          }
        });
      } else {
        appointAPI().then((response) => {
          if (response.code == 200) {
            this.activity.is_send = 1
            this.showPopup('orderSuccessShow');
            this.logger.sum('拳新版本组队-预约成功');
          } else {
            this.onToast(response.message);
          }
        });

      }
    },
    clickRewardType(index) {
      this.reward_type = index;
    },
    // 获取积分对应的百分比
    getPercentByScore() {
      const score = this.activity.team[this.reward_type + '_score']
      // const score = 400
      if (!score) return '0%'

      const mapping = this.mapping[this.reward_type]
      if (!mapping) return '0%'

      // ⚠️ 修改部分：score <= 最小节点时，也按比例算（从0开始）
      const min = mapping[0]
      if (score <= min.score) {
        const ratio = score / min.score
        return (ratio * min.percent).toFixed(2) + '%'
      }

      // 大于最大值，按比例映射，最多 100%
      const max = mapping[mapping.length - 1]
      if (score >= max.score) {
        const extraRatio = (score - max.score) / max.score
        let percent = max.percent + extraRatio * (100 - max.percent)
        return (percent > 100 ? 100 : percent).toFixed(2) + '%'
      }

      // 区间内线性插值
      for (let i = 0; i < mapping.length - 1; i++) {
        const cur = mapping[i]
        const next = mapping[i + 1]
        if (score >= cur.score && score <= next.score) {
          const ratio = (score - cur.score) / (next.score - cur.score)
          return (cur.percent + ratio * (next.percent - cur.percent)).toFixed(2) + '%'
        }
      }

      return '0%'
    },
    // 事件委托
    handleGlobalClick(e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-tideng-report-name')) {
          const reportName = el.getAttribute('data-tideng-report-name');
          this.logger.sum(`拳新版本组队-${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    // 选择角色后
    selectCallback(response) {
      this.selectCallback_Info = response;
      this.onInitDate()
    },
    onInitState(response) {
      console.log(response, '初始化数据成功');
      const { code } = response || {}
      if (response.code == 200) {

        const user = Object.assign(response.data.user_info, this.selectCallback_Info);
        console.log(user, '初始化数据成功');
        this.setUserInfo(user);
        this.newUserInfo = JSON.parse(JSON.stringify(user))
        if (response.data.activity.is_bind) {
          delete this.newUserInfo.role_name
        }
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        if (!this.isLogin()) {
          return
        }
      }
    },
    // 初始化
    async onInitDate(isFirst = false) {
      const that = this
      await onGetInitDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });
        if (response.code !== 200) {
          !isFirst && this.onToast(response.message);
          if (this.friend_id) {
            this.changeLoginPopup(true)
          }
          return;
        }
        this.optStastus = response.data.activity.is_reward_start ? response.data.activity.is_send : response.data.activity.is_book
        response.data.activity.team.self_package_list = response.data.activity.team.self_package_list.flatMap(item => {
          if (item.number <= 2) {
            // 1, 2 保持原样
            return [item]
          } else {
            // 3-7 每个复制为两个对象（深拷贝）
            return [{ ...item }, { ...item }]
          }
        })
        response.data.activity.team.team_package_list = response.data.activity.team.team_package_list.flatMap(item => {
          if (item.number <= 2) {
            // 1, 2 保持原样
            return [item]
          } else {
            // 3-7 每个复制为两个对象（深拷贝）
            return [{ ...item }, { ...item }]
          }
        })
        that.activity = response.data.activity;
        if (response.data.user_info.rid) {
          response.data.user_info.role_id = response.data.user_info.rid
        }
        that.onInitState(response);
        // that.initShareData();
        that.getTeamListData();
        this.task_info = this.task_info.map(localItem => {
          const remote = response.data.activity.team.task_info.find(r => r.task_id === localItem.task_id);
          if (remote) {
            const { img, img_old } = localItem;
            return {
              ...remote,
              img,
              img_old
            }
          }
          return localItem;
        })

        if (this.friend_id) {
          if (response.data.activity.is_bind == 0) {
            that.showPopup('bindShow')
          } else {
            that.getTeamInit()
          }
        }

        return response
        // this.invitePartnerInfo = this.activeInfo.invite.invite_list[0] || {};
        // this.teamScore = Number(this.activeInfo.team.team_score) || 0;
        // this.scoreList = this.activeInfo.team.score_list || [];
        // this.rewardLevel = Number(this.activeInfo.team.level) || 0;
        // this.rewardList = this.activeInfo.team.reward_list || [];
        // this.packageList = this.activeInfo.team.package_list || [];

        // this.qqNumber = this.activeInfo.qq;
        // this.qqLink = this.activeInfo.qq_link;
        // this.wechatLink = this.activeInfo.invite.url_scheme;
        // if (this.activeInfo.team.is_has_out_news) {
        //   this.showPopup('teamKickOutTipShow');
        // }
        // // 设置welfare-list的滚动位置
        // const targetElement = document.getElementsByClassName('welfare-list');
        // const idx = this.packageList.findIndex(item => item._get && !item.is_get);
        // if (targetElement[0] && idx !== -1) {
        //   targetElement[0].scrollTop = document.getElementsByClassName(`reward-item-${idx + 1}`)[0].offsetTop - 10;
        // }
      });
    },
    clearDate() {
      this.teamActiveInfo = {};
      this.recallActiveInfo = {};
      this.teamList = Array.from({ length: 4 }, () => ({}));
      this.packageList = Array.from({ length: 10 }, () => ({}));
      this.memberNum = 0;
      this.roleList = [];
      this.invitePartnerInfo = {};
      this.recallSharePlayerInfo = {};
      this.teamScore = 0;
      this.scoreList = [];
      this.rewardLevel = 0;
      this.rewardList = [];
      this.selectedRoleInfo = {};
      this.recallShareImg = '';
      this.teamShareImg = '';
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.recallShareCopy = {
        title: '',
        desc: '',
        linkText: ''
      };
      this.teamShareCopy = {
        title: '',
        desc: '',
        linkText: ''
      };
      this.newUserInfo = {};
      this.$set(this, 'newUserInfo', {})
      this.task_info = [
        {
          task_id: 1,
          title: '游戏充值每满6元',
          type: 1,
          is_limit: 1,
          score: 150,
          add_score: 200,
          package_id: 1,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/pay.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/pay.png'
        },
        {
          task_id: 2,
          title: '每日登录游戏',
          type: 2,
          is_limit: 1,
          score: 100,
          add_score: 200,
          package_id: 462,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login1.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login1.png'
        },
        {
          task_id: 3,
          title: '每日消耗100精力',
          type: 3,
          is_limit: 100,
          score: 100,
          add_score: 200,
          package_id: 0,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy.png'
        },
        {
          task_id: 4,
          title: '精力消耗达200点',
          type: 3,
          is_limit: 200,
          score: 200,
          add_score: 300,
          package_id: 0,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy200.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy200.png'
        },
        {
          task_id: 5,
          title: '精力消耗达400点',
          type: 3,
          is_limit: 400,
          score: 400,
          add_score: 600,
          package_id: 463,
          desc: '(内含以下游戏道具奖励)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy400.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy400.png'
        },
        {
          task_id: 6,
          title: '精力消耗达600点',
          type: 3,
          is_limit: 600,
          score: 600,
          add_score: 900,
          package_id: 0,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy600.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy600.png'
        },
        {
          task_id: 7,
          title: '精力消耗达1000点',
          type: 3,
          is_limit: 1000,
          score: 1000,
          add_score: 1500,
          package_id: 462,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/energy1000.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/energy1000.png'
        },
        {
          task_id: 8,
          title: '完成登录2天',
          type: 4,
          is_limit: 2,
          package_id: 0,
          score: 100,
          add_score: 150,
          desc: '(元素材料为随机发放)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login2.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login2.png'
        },
        {
          task_id: 9,
          title: '完成登录3天',
          type: 4,
          is_limit: 3,
          package_id: 0,
          score: 300,
          add_score: 450,
          desc: '',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login3.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login3.png'
        },
        {
          task_id: 10,
          title: '完成登录5天',
          type: 4,
          is_limit: 5,
          package_id: 463,
          score: 500,
          add_score: 750,
          desc: '(内含以下游戏道具奖励)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login5.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login5.png'
        },
        {
          task_id: 11,
          title: '完成登录7天',
          type: 4,
          is_limit: 7,
          package_id: 463,
          score: 1000,
          add_score: 1500,
          desc: '(内含以下游戏道具奖励)',
          img: 'https://download4.qcplay.com/h5-images/active/tideng/recall/login7.png',
          img_old: 'https://download4.qcplay.com/h5-images/active/tideng/recall/active/login7.png'
        }
      ],
        this.activity = {
          is_bind: 0,
          is_send: 0,
          team: {
            status: 0,
            "team_score": 0,
            "code": "",
            "self_score": 0,
            "team_status": 0,
            team_list: [],
            is_first: 3,
            "self_package_list": [
              {
                "number": 1,
                "score": 100,
                "_get": false,
                "is_get": false
              },
              {
                "number": 2,
                "score": 500,
                "_get": false,
                "is_get": false
              },
              {
                "number": 3,
                "score": 1000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 4,
                "score": 5000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 5,
                "score": 6000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 6,
                "score": 7000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 7,
                "score": 8000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 8,
                "score": 9000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 9,
                "score": 10000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 10,
                "score": 11000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 11,
                "score": 12000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 12,
                "score": 13000,
                "_get": false,
                "is_get": false
              },
            ],
            "team_package_list": [
              {
                "number": 1,
                "score": 500,
                "_get": false,
                "is_get": false
              },
              {
                "number": 2,
                "score": 1500,
                "_get": false,
                "is_get": false
              },
              {
                "number": 3,
                "score": 5000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 4,
                "score": 10000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 5,
                "score": 15000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 6,
                "score": 20000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 7,
                "score": 30000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 8,
                "score": 9000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 9,
                "score": 10000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 10,
                "score": 11000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 11,
                "score": 12000,
                "_get": false,
                "is_get": false
              },
              {
                "number": 12,
                "score": 13000,
                "_get": false,
                "is_get": false
              },
            ],
          },
          user_info: {}
        },
        this.$set(this.activity, 'user_info', this.userInfo);
      this.getPercentByScore()
    },
    async getTeamInit() {
      if (this.friend_id) {
        const response = await inviteTeamInit({ code: this.friend_id });
        console.log(response, '加入队伍初始化');
        if (response.code === 200) {
          const { is_my, number, is_join, level } = response.data.activity;
          if (is_my) {
            this.showPopup('teamJoinFailedMyselfShow');
          } else if (is_join) {
            this.showPopup('teamJoinFailedHasTeamShow');
          } else if (number === 4) {
            this.showPopup('teamJoinFailedFullStrengthShow');
          } else {
            if (this.isActiveAppointment === false) {// 如果是非预组队期间
              this.needInvitationConfirm = true;
            }
            // this.teamInvitationNum = number === 0 ? 1 : number;
            this.teamInvitationNum = number;
            this.teamLevel = level;
            // this.onInitState(response)
            this.showPopup('teamInvitationJoinShow')
          }
        } else {
          this.onToast(response.message);
        }
      }
    },
    goLink(url) {
      if (url === '') return
      this.logger.sum('拳新版本组队-立即关注');
      Indicator.open();
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    // 跳转到首页
    toIndex(popupName) {
      this.closePopup(popupName);
      this.recallSharePlayerInfo = {};
      const { protocol, host } = window.location;
      window.location.href = `${protocol}//${host}/tideng/recall/anniversary${getRandomString()}`;
    },
    toGroupOfQQ() {
      if (wechatBrowser()) {
        this.closePopup('recallFailedMismatchConditionShow2');
        this.closePopup('findTeamShow');

        this.showPopup('qqGroupShow');
      } else {
        window.location.href = this.qqLink;
      }
    },
    toGroupOfWechat() {
      window.location.href = this.wechatLink;
    },
    initTeamShareData() {
      try {
        // 生成一个随机数，用于判断随机使用两种文案中的一种
        const randomNum = Math.random();
        if (randomNum > 0.5) {
          this.teamShareCopy = {
            title: "《提灯与地下城》新版本上线",
            desc: "《提灯与地下城》组队积分活动，可获得史诗级头衔：海灵主宰·龙拳破天、10星装备升星券、钻石*1000等丰厚奖励，集结归来的灯友，就差你了！",
            linkText: '《提灯与地下城》组队积分活动，可获得史诗级头衔：海灵主宰·龙拳破天、10星装备升星券、钻石*1000等丰厚奖励，集结归来的灯友，就差你了！',
          };
        } else {
          this.teamShareCopy = {
            title: "《提灯与地下城》新版本上线",
            desc: "《提灯与地下城》组队积分活动，可获得史诗级头衔：海灵主宰·龙拳破天、10星装备升星券、钻石*1000等丰厚奖励，集结归来的灯友，就差你了！",
            linkText: '《提灯与地下城》组队积分活动，可获得史诗级头衔：海灵主宰·龙拳破天、10星装备升星券、钻石*1000等丰厚奖励，集结归来的灯友，就差你了！',
          };
        }

        this.qrcode('team-qrcode', `${this.teamShareLink}`);
        this.$nextTick(() => {
          this.generateTeamShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('组队分享初始化失败', err);
      }
    },
    // 生成二维码
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#2a5a4d',
        colorLight: '#9ea593'
      });
    },
    onCopy(id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    // 分享图片设置
    generateRecallShareImage() {
      generateCanvasImage(this.$refs.recallImageDom)
        .then((canvas) => {
          this.recallShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('召回分享图生成成功');
        })
        .catch((err) => {
          console.log('召回分享图生成失败', err.message);
        });
    },
    generateTeamShareImage(successCallback, failedCallback) {
      generateCanvasImage(this.$refs.teamImageDom)
        .then((canvas) => {
          this.teamShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          successCallback && successCallback();
          console.log('组队分享图生成成功');
        })
        .catch((err) => {
          failedCallback && failedCallback();
          console.log('组队分享图生成失败', err.message);
        });
    },
    onRecallShare() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.activeInfo.invite.is_start) {
        this.onToast('活动将于6月20日5:00开启，敬请期待');
        return;
      }
      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?code=${this.activeInfo.invite.code}`
        window.history.replaceState(null, '', newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.recallShareLink,
          title: this.recallShareCopy.title,
          imgUrl: 'https://download4.qcplay.com/qcgame-api/9VHWniV91Q3sfOtCISCEmR9aWVEaAj7jLqrT2VKZ.png',
          desc: this.recallShareCopy.desc,
        });
        this.recallWechatShareShow = true;
        this.logger.sum('拳新版本组队-wx-引导遮罩')
      } else {
        this.recallNotWechatShareShow = true;
      }
    },
    onTeamShare() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.userInfo.role_id === undefined) {
        this.changeOsPopup(true);
        return;
      }
      if (this.activity.is_bind === 0) {
        this.showPopup('bindShow');
        return;
      }
      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?friend_id=${this.activeInfo.team.team_code}`
        window.history.replaceState(null, '', newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.teamShareLink,
          title: '《提灯与地下城》新版本火热上线',
          imgUrl: 'https://download4.qcplay.com/qcgame-api/9VHWniV91Q3sfOtCISCEmR9aWVEaAj7jLqrT2VKZ.png',
          desc: '参与组队积分活动，可获得史诗级头衔、10星装备升星券等丰厚奖励，集结归来的灯友，就差你了！',
        });
        this.showPopup('teamWechatShareShow');
        this.logger.sum('拳新版本组队-wx-引导遮罩')
      } else {
        this.onPreventShow();
        this.generateTeamShareImage(() => {
          this.onPreventClose();
          this.showPopup('teamNotWechatShareShow');
        }, () => {
          this.onPreventClose();
        })
      }
    },
    closeWechatShare(popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, '', window.location.pathname);
    },
    getTeamListData() {
      let teamList = this.activity.team.team_list || [];
      teamList.forEach((item) => {
        const { y, m, d, h, status } = item;
        if (y) {
          item.lastTime = `${y}年前`;
        } else if (m) {
          item.lastTime = `${m}月前`;
        } else if (d) {
          item.lastTime = `${d}天前`;
        } else {
          item.lastTime = '今天';
        }
        item.type_desc = PLAYER_TYPE[status];
        item.is_myself = this.userInfo.user_id === item.id;
        item.is_kick_out = this.activity.team.activity_status === ACTIVE_APPOINTMENT_STATUS &&
          this.activity.team.is_first && !item.is_myself;
      });
      // 如果teamList长度小于6，用空对象填充
      if (teamList.length < 4) {
        const fillCount = 4 - teamList.length;
        const fillArray = Array.from({ length: fillCount }, () => ({}));
        teamList = teamList.concat(fillArray);
      }
      this.teamList = teamList;
      this.memberNum = this.activeInfo.team.team_list.length;
    },
    // 接受邀请
    async acceptInvitation() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await recallBindPlayerAPI({ code: this.code });
      switch (response.code) {
        case 200:
          this.onToast('绑定成功');
          this.onInitDate();
          break;
        case 405:
          // 对方队伍已满员
          this.showPopup('recallFailedFullStrengthShow');
          break;
        case 406: // 不能自己绑定自己 
          this.showPopup('recallFailedMyselfShow');
          break;
        case 407: // 不符合条件
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 408: // 不符合条件
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 501:
          // 自己已经有队伍
          this.showPopup('recallFailedHasTeamShow');
          break;
        case 502:
          // 两个都是回归玩家
          this.showPopup('recallFailedMismatchConditionShow2');
          break;
        case 503: // 不符合条件 有一个人是新玩家的时候
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 504: // 不符合条件 两个活跃玩家
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        default:
          this.onToast(response.message);
      }

      this.onPreventClose();
      this.closePopup('recallInvitationShow');
      this.recallSharePlayerInfo = {};
    },
    toMyTeamByRecall() {
      this.closePopup('recallFailedHasTeamShow');
      this.scrollIntoRecallBox();
    },
    // 查看我的组队
    toMyTeamByTeam() {
      this.closePopup('teamJoinFailedMyselfShow');
      this.closePopup('teamJoinFailedHasTeamShow');
      // TODO: 锁定到页面召回板块
      this.scrollIntoTeamBox();
    },
    scrollIntoRecallBox() {
      const targetElement = document.getElementById('recall-box');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollIntoTeamBox() {
      const targetElement = document.getElementById('team-consumption-box');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    onRecallOther() {
      if (this.userInfo.game_id === 26 || this.activeInfo.invite.status === 3) {
        this.onToast('召回失败！尚未满足触发条件！');
        return;
      }
      this.closePopup('recallFailedMismatchConditionShow');
      this.closePopup('recallFailedFullStrengthShow');
      this.closePopup('recallFailedMyselfShow');
      this.closePopup('recallFailedHasTeamShow');
      this.onRecallShare();
    },
    readPlayerInfo(id) {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.userInfo.role_id === undefined) {
        this.changeOsPopup(true);
        return;
      }
      if (this.activity.is_bind === 0) {
        this.showPopup('bindShow');
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      this.showPopup('teamPlayerInfoShow');
    },
    quitPlayerInfo(id) {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.userInfo.role_id === undefined) {
        this.changeOsPopup(true);
        return;
      }
      if (this.activity.is_bind === 0) {
        this.showPopup('bindShow');
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      this.showPopup('teamPlayerKickOutInfoShow');
    },
    // 踢出队伍
    async onKickOut(flag, item) {
      if (flag === 'team') {
        this.curPlayerInfo = item
      } else {
        this.curPlayerInfo = this.teamList.find(item => item.id === this.userInfo.user_id);
      }
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamKickAPI({ id: this.curPlayerInfo.id });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('已踢出队伍');
        this.closePopup('teamPlayerKickOutInfoShow');
        this.onInitDate();
        this.logger.sum('拳新版本组队-弹窗-踢出队伍');
      }
      this.onPreventClose();
    },
    // 查看更多积分
    onMorePoints() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.teamScore) {
        this.showPopup('teamPointsRecordShow');
      } else {
        this.showPopup('teamNotPointsRecordShow');
      }
    },
    // 跳转到充值网站
    toRecharge() {
      window.location.href = this.rechargeUrl;
    },
    async onExitTeam() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      teamExitAPI().then((response) => {
        if (response.code !== 200) {
          this.onToast(response.message);
        } else {
          this.closePopup('teamExitShow');
          this.onInitDate();
        }
        this.onPreventClose();
      })

    },
    async rejectJoinTeam() {
      this.toIndex('teamInvitationJoinShow');
    },
    async agreeJoinTeam() {
      if (this.needInvitationConfirm) {
        this.closePopup('teamInvitationJoinShow');
        this.showPopup('teamInvitationConfirmShow');
        this.needInvitationConfirm = false;
        return;
      }
      this.onPreventShow();
      const response = await teamJoinAPI({ code: this.friend_id });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('入队成功');
      }
      this.onPreventClose();
      this.closePopup('teamInvitationJoinShow');
      this.closePopup('teamInvitationConfirmShow');
      this.onInitDate();
    },
    // 领取奖励
    async onReward() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.userInfo.role_id) {
        this.changeOsPopup(true);
        return;
      }
      if (this.activity.is_bind === 0) {
        this.showPopup('bindShow');
        return;
      }
      this.onPreventShow();
      const praams = {
        ...this.userInfo,
        type: this.reward_type === 'self' ? 1 : 2,
        platform: this.userInfo.channel
      }
      const response = await teamRewardAPI(praams);
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('领取成功');
        this.onInitDate();
      }
      this.onPreventClose();
    },
    closeReConfirmBindRole() {
      this.selectedRoleInfo = {};
      this.closePopup('teamBindRoleConfirmShow');
    },
    confirmBindRole() {
      this.onPreventShow();
      teamRewardAPI({
        ...this.selectedRoleInfo,
        is_bind: 1,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.closePopup("teamBindRoleConfirmShow");
          this.onToast('绑定成功');
          this.onInitDate();
        } else {
          this.onToast(response.message);
        }
      }).finally(() => {
        this.onPreventClose();
      });
    },
    loginSuccess() {
      this.onInitDate();
    },
    clickReward(id) {
      const popupList = [
        'activityBenefitsShow', 'characterShow', 'activityBenefitsShow', 'valuablesShow', 'activityBenefitsShow',
        'activityBenefitsShow', 'crystalShow', 'activityBenefitsShow', 'cooperationShow', 'luckyShow'
      ];
      const popupName = popupList[id];
      if (popupName) {
        this.showPopup(popupName);
      }
    },
    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${minutes >= 10 ? minutes : '0' + minutes}:${seconds >= 10 ? seconds : '0' + seconds}`;
    },
    openLoginByScore() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    openLoginByPlayer() {
      console.log(this.userInfo.user_id)
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    // TAG: 其他简易封装的方法
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    // 打开遮罩
    onPreventShow() {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose() {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup(name) {
      if (name === 'ruleShow') {
        this.logger.sum('拳新版本组队' + name);
        return this[name] = true;
      }
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.userInfo.role_id) {
        this.changeOsPopup(true);
        return;
      }
      this.logger.sum('拳新版本组队-开启' + name);
      this[name] = true;
    },
    closePopup(name) {
      if (name === 'teamInvitationJoinShow') {
        this.friend_id = '';
      }
      this.logger.sum('拳新版本组队-关闭' + name);
      this[name] = false;
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>


// WEBPACK FOOTER //
// src/pages/tideng/recall/index/index.vue